import { axios } from "@/plugins/axios"
import store from "@/store"
import { app } from "@/main"


export async function getLicense() {
  const licenseApi = "/system/license";
  let license = {}

  await axios
    .get(licenseApi)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("systemNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    })
    .then((response) => {
      if (response.data.license != undefined) {
        license = response.data.license
      }
    })

  return license
}